import { ChartData } from '@/types';
import styles from './indicator.module.scss';

interface IndicatorPros extends Pick<ChartData, 'indicator'> {
  isFirstTab: boolean;
}

export const Indicator = ({ indicator, isFirstTab }: IndicatorPros) => {
  return (
    <div className={styles.indicator}>
      <div className={styles.indicator_container}>
        <div
          className={`${styles.indicator_wrapper} ${isFirstTab ? '' : styles.second}`}
        >
          <span>{indicator.credit}</span>
          <span>{indicator.income}</span>
        </div>
      </div>
    </div>
  );
};
